module.exports = __webpack_public_path__ + "static/media/Icon.3b7938f2.scss";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/Icon.scss
// module id = 822
// module chunks = 21